//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loader: true,
      model: {
        parataxEn: false,
        parataxPerc: '',
        parataxPercFix: false,
        paraminingMaxPerc: '',
        paraminingBeginTime: '',
      },
      addingStakingSettings: {
        modal: false,
        input: {
          balance: '',
          perc: '',
        },
      },
    };
  },

  computed: {
    ...mapState('stakingCurrencies', ['paraminingData']),

    id() {
      const { currencyId } = this.data;
      return currencyId;
    },

    parataxPercFixItems() {
      return [
        { id: true, caption: this.$t('Manual') },
        { id: false, caption: this.$t('From blockchain') },
      ];
    },

    stakingBalanceList() {
      const { stakingBalanceList } = this.paraminingData;
      if (!stakingBalanceList) return [];

      return stakingBalanceList;
    },

    isAddingStakingSettingsDisabled() {
      const { balance, perc } = this.addingStakingSettings.input;
      return !(balance && perc);
    },
  },

  watch: {
    async id(value) {
      this.setModel();
      this.setGeneralProgress(true);
      this.loader = true;
      await this.getParaminingDataAction({ currencyId: value });
      this.setGeneralProgress(false);
      this.loader = false;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('stakingCurrencies', {
      getParaminingDataAction: 'getParaminingData',
      addStakingSettingsAction: 'addStakingSettings',
      removeStakingSettingsAction: 'removeStakingSettings',
    }),

    setModel() {
      const {
        feeEn,
        feePerc,
        feePercFix,
        percMax,
        beginTime,
      } = this.data;
      this.model.parataxEn = feeEn;
      this.model.parataxPerc = feePerc;
      this.model.parataxPercFix = feePercFix;
      this.model.paraminingMaxPerc = percMax;
      this.model.paraminingBeginTime = beginTime;
    },

    apply() {
      const { model } = this;
      this.$emit('apply', model);
    },

    disable() {
      this.$emit('disable');
    },

    addStakingSettings() {
      this.addingStakingSettings.input.balance = '';
      this.addingStakingSettings.input.perc = '';
      this.addingStakingSettings.modal = true;
    },

    applyAddStakingSettings() {
      this.confirmAction({
        title: 'Are you sure you want to add new settings?',
        callback: async () => {
          const { id } = this;
          const { balance, perc } = this.addingStakingSettings.input;
          const payload = {
            currencyId: id,
            balance,
            perc,
          };
          this.setGeneralProgress(true);
          try {
            await this.addStakingSettingsAction(payload);
            this.addingStakingSettings.modal = false;
            this.loader = true;
            await this.getParaminingDataAction({ currencyId: id });
            this.loader = false;
            this.setSuccessNotification('Staking settings successfully added');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
        },
      });
    },

    removeStakingSettings(balance) {
      this.confirmAction({
        title: 'Are you sure you want to remove this settings?',
        callback: async () => {
          const { id } = this;
          const payload = {
            currencyId: id,
            balance,
          };
          this.setGeneralProgress(true);
          try {
            await this.removeStakingSettingsAction(payload);
            this.loader = true;
            await this.getParaminingDataAction({ currencyId: id });
            this.loader = false;
            this.setSuccessNotification('Staking settings successfully removed');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
        },
      });
    },
  },
};
